"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheFinalDetail() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="262818" id="the-final-detail" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 px-4 lg:px-8 flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-10 select-none overflow-hidden">
        <Quote className="w-[150vw] h-[150vw] md:w-[80vw] md:h-[80vw] text-secondary -rotate-12 translate-y-12" strokeWidth={0.5} />
      </div>

      {}
      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto flex flex-col items-center gap-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <blockquote className="text-center">
          <p className="font-serif italic text-3xl md:text-4xl lg:text-[40px] leading-relaxed md:leading-loose text-foreground tracking-tight">
            "It is the subtle textures and the quiet elegance of the small things that truly define the atmosphere of a Signature Occasion."
          </p>
        </blockquote>

        <div className="flex flex-col items-center gap-5">
          <SafeHydrate><Avatar className="w-20 h-20 border-2 border-primary/20 shadow-xl">
            <AvatarImage src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/floral_texture_detail.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/floral_texture_detail.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/floral_texture_detail.png-wvc-sizes" alt="Atmosphere Detail" />
            <AvatarFallback className="bg-muted text-primary font-default font-semibold text-xl">
              SO
            </AvatarFallback>
          </Avatar></SafeHydrate>
          <div className="text-center">
            <div className="font-default font-semibold text-xl text-foreground tracking-wide">
              The Final Detail
            </div>
            <div className="text-primary text-sm tracking-widest uppercase mt-1.5 font-medium">
              Art of Atmosphere
            </div>
          </div>
        </div>
      </div>
    </section>;
}